import { render, staticRenderFns } from "./SuccessStories.vue?vue&type=template&id=23cb4bdb&scoped=true&"
import script from "./SuccessStories.vue?vue&type=script&lang=js&"
export * from "./SuccessStories.vue?vue&type=script&lang=js&"
import style0 from "./SuccessStories.vue?vue&type=style&index=0&id=23cb4bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb4bdb",
  null
  
)

export default component.exports